export default __webpack_public_path__ + "static/media/edit-regular.3c9aad14.svg";